import { render, staticRenderFns } from "./ChangeBankRequired.vue?vue&type=template&id=5e1af81b"
import script from "./ChangeBankRequired.vue?vue&type=script&lang=js"
export * from "./ChangeBankRequired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports